//import { Injectable } from '@angular/core';

declare var AWS: any;

//@Injectable()
export class Ladder {
    
    public DayEnding: string = null;
    public Category:string = "Main";
    public VoteEnding:string = new Date().toISOString();
    
    constructor()
    {
        //let test = "d";

    }

    public getVoteStartDate(){
        let workingDate = this.parseISOString(this.VoteEnding);
        let days = -7;
        workingDate.setTime(workingDate.getTime() + (days * 86400000));
        return workingDate.toISOString();
    }

    parseISOString(s) {
        var b = s.split(/\D+/);
        return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
    }
}



// WEBPACK FOOTER //
// ./src/providers/ladder.ts